import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { ChevronDownSolidIcon } from '@compono/ui-icons';
import { useTheme } from '../hooks/useTheme.js';
import { useDisclosureContext } from './DisclosureProvider.js';

var DisclosureArrowIcon = function DisclosureArrowIcon(_a) {
    var _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, props = __rest(_a, ["isOpen"]);
    var handleStyleProps = useTheme().handleStyleProps;
    var context = useDisclosureContext({ optional: true });
    var isOpenArg = isOpen || context.isOpen;
    var forwardProps = handleStyleProps(props, {
        baseStyle: {
            transform: "scaleY(".concat(isOpenArg ? -1 : 1, ")"),
            transition: "transform ease-in-out",
            transitionDuration: 5,
        },
    });
    return jsx(ChevronDownSolidIcon, __assign({}, forwardProps));
};

export { DisclosureArrowIcon };
//# sourceMappingURL=DisclosureArrowIcon.js.map
